/** @jsx h */
import { searchHeading, searchIntro } from '../config';

const Header = () => {
  return (
    <div className="image-teaser-big image-teaser-big--search">
      <div className="image-teaser-big__image">
        <div className="image-teaser-big__text">
          <svg
            className="image-teaser-big__svg"
            viewBox="0 0 953 126"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path d="M0 64L168.5 0L953 123V126L0 126L0 64Z" />
          </svg>
          <div className="image-teaser-big__text-inner">
            <div className="image-teaser-big__text-inner-wrapper">
              {searchHeading && (
                <h2 className="image-teaser-big__title">{searchHeading}</h2>
              )}
              {searchIntro && <p className="text-l">{searchIntro}</p>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
